<template>
  <div class="com-mod-section-container">
    <h3 class="com-mod-section-header">
      Holdings
      <disclosure-superscript
        class="detail-page"
        anchor="holdingsTitle"
        :statistics="['TTLHLD']"
      />
    </h3>
    <div class="row">
      <div class="col-md-12 adjust-up">
        <div v-if="isAuthorizedModule['bondBreakdown']" id="_bondBreakdown">
          <breakdown-bond :bond-breakdown-data="getBondbreakdown || {}" />
        </div>
        <div v-if="isAuthorizedModule['equityBondBreakdown']" id="_equityBondBreakdown">
          <breakdown-equity-and-bond
            :bond-breakdown-data="getBondbreakdown || {}"
            :equity-breakdown-data="getEQbreakdown"
          />
        </div>
        <div v-if="isAuthorizedModule['equityBreakdown']" id="_equityBreakdown">
          <breakdown-equity :equity-breakdown-data="getEQbreakdown" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <geographic-breakdown v-if="isAuthorizedModule['geoBreakdown']" id="_geoBreakdown"/>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <geography-investing v-if="isAuthorizedModule['geoInvesting']" id="_geoInvesting"/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import GeographyInvesting from '_components_/Modules/GeographyInvesting';
import BreakdownEquityAndBond from '_components_/Modules/BreakdownEquityAndBond';
import BreakdownBond from '_components_/Modules/BreakdownBond';
import BreakdownEquity from '_components_/Modules/BreakdownEquity';
import GeographicBreakdown from '_components_/Modules/GeographicBreakdown';
export default {
	name: 'Holdings',
	components: {
		BreakdownEquityAndBond,
		BreakdownBond,
		BreakdownEquity,
		GeographyInvesting,
		'geographic-breakdown': GeographicBreakdown
	},
	computed: {
		...mapGetters([
			'getFundAttributes',
			'getAudience',
			'getEQbreakdown',
			'getBondbreakdown'
		])
	}
};
</script>

<style scoped lang="less">
	@import '~_css_/module.css';
	#afis-app .com-mod-section-container .com-mod-section-header {
		margin-bottom: 20px;
	}
	.adjust-up {
		margin-bottom: 35px; //need to give extra space in breakdown module to combat CG bootstrap files and match American Funds.
	}
</style>
